import { render, staticRenderFns } from "./argument.vue?vue&type=template&id=0a96ee3b&scoped=true&"
import script from "./argument.vue?vue&type=script&lang=js&"
export * from "./argument.vue?vue&type=script&lang=js&"
import style0 from "./argument.vue?vue&type=style&index=0&id=0a96ee3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96ee3b",
  null
  
)

export default component.exports